export function getPlatformScreenshotSources(tool) {
  const key = String(tool?.key || '').trim().toLowerCase();
  if (!key) return null;
  return {
    primary: `/platform-screenshots/${encodeURIComponent(key)}.jpg`,
    fallback: '/platform-screenshots/_default.jpg',
  };
}

export function getPlatformLogoSources(tool) {
  const fromApi = String(tool?.logoUrl || '').trim();
  if (fromApi) {
    return {
      primary: fromApi,
      fallback: '/platform-logos/_default.png',
    };
  }

  const key = String(tool?.key || '').trim().toLowerCase();
  if (!key) return null;
  return {
    primary: `/platform-logos/${encodeURIComponent(key)}.png`,
    fallback: '/platform-logos/_default.png',
  };
}

let launchOverlayEl = null;

function showPlatformLaunchOverlay() {
  if (launchOverlayEl) return;
  const el = document.createElement('div');
  el.className = 'platform-launch-overlay';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.innerHTML = '<div class="platform-launch-overlay-card"><span class="spin platform-launch-spinner" aria-hidden="true"></span><span>Opening platform…</span></div>';
  document.body.appendChild(el);
  launchOverlayEl = el;
}

export async function openPlatformTool(tool, navigate) {
  if (!tool) return false;

  const rawUrl = String(tool.url || '').trim();
  const isHkClaim = /hkclaim/i.test(String(tool.key || '')) || /hk\s*claim/i.test(String(tool.name || ''));
  const url = rawUrl && !rawUrl.startsWith('http://') && !rawUrl.startsWith('https://') && !rawUrl.startsWith('/')
    ? `/${rawUrl}`
    : rawUrl;

  if (!url) return false;

  if (url.startsWith('http://') || url.startsWith('https://')) {
    const platformCode = String(tool.key || '').trim().toLowerCase();
    const ssoPlatform = platformCode || (isHkClaim ? 'hkclaim' : '');
    if (ssoPlatform) {
      showPlatformLaunchOverlay();
      // Server-side start issues the handoff code and 302s in one navigation — faster than
      // waiting for a client-side issue-code round-trip before leaving the portal.
      window.location.assign(`/api/sso/start?platform=${encodeURIComponent(ssoPlatform)}&returnUrl=${encodeURIComponent(url)}`);
      return true;
    }
    window.location.assign(url);
    return true;
  }

  if (typeof navigate === 'function') {
    navigate(url);
    return true;
  }

  window.location.assign(url);
  return true;
}
